// extracted by mini-css-extract-plugin
export default {"tab":"Tab_tab__pYSj6","tab__inner":"Tab_tab__inner__YJ-Ee","tab__close-btn":"Tab_tab__close-btn__4bxFN","tab__close-icon":"Tab_tab__close-icon__7bv5M"};